import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-safe",
  "use": "icon-safe-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 60 60\" id=\"icon-safe\">\r\n<style type=\"text/css\">\r\n\t#icon-safe .st0{fill:#9CCEC1;}\r\n</style>\r\n<path class=\"st0\" d=\"M54.3,13.7c-0.1-1.7-1.5-3.3-3.1-3.6c0,0-6.5-1-10.1-2.3c-4.5-1.6-9-5.1-9-5.1c-1.4-1-3.5-0.9-4.8,0.1\r\n\tc0,0-3.2,3.2-9.1,5c-5,2-9.1,2.3-9.7,2.4c-0.1,0-0.1,0-0.2,0c-1.6,0.3-3,1.7-3,3.4c0,0-0.2,8.7,0.1,16.3C5.4,43.6,21.7,57,29.9,57\r\n\tc8.1,0,22-9.4,24.2-26.9C54.6,19.8,54.3,13.7,54.3,13.7L54.3,13.7z M46.9,22.6L46.9,22.6L28,40.2c-0.9,0.8-2.1,0.9-3.1,0.3l-0.5-0.4\r\n\tL13.9,29.3c-1-1-0.9-2.7,0.1-3.6c0,0,0,0,0,0c1.1-1,2.7-0.9,3.7,0.2l8.6,9l17-16c1.1-1,2.7-0.9,3.7,0.2C48,20,48,21.6,46.9,22.6\r\n\tC47,22.6,46.9,22.6,46.9,22.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/safe.svg
// module id = 1Bju
// module chunks = 87